define(
  "SDB.Financing.View",
  [
    "sdb_financing_template.tpl",
    "SCView",
    "Utils",
  ],
  function (
    financing_tpl,
    SCViewComponent,
    Utils,
  ) {
    "use strict";

    var SCView = SCViewComponent.SCView;

    function SDBFinancingView(options) {
      SCView.call(this);
      var self = this;
      this.template = financing_tpl;
      this.options = options || {};
      this.env = this.options.container.getComponent("Environment");

      this.events = {};

      this.getContext = function () {
        var bannerConfig = this.env.getConfig("SDBLocations.FinancingBanner") || {};
        var desktopImageConfig = (bannerConfig.desktopImage || "").trim();
        var tabletImageConfig = (bannerConfig.tabletImage || "").trim();
        var mobileImageConfig = (bannerConfig.mobileImage || "").trim();
        var hasBannerImages =
          !!desktopImageConfig || !!tabletImageConfig || !!mobileImageConfig;
        var desktopImage = desktopImageConfig || null;
        var tabletImage = tabletImageConfig || desktopImage;
        var mobileImage = mobileImageConfig || tabletImage;
        var bannerAltText =
          bannerConfig.altText || "Buy Now Pay Later Canada Custom Autoworks";

        var deviceType = Utils.getDeviceType();
        var bannerImage = desktopImage;
        var bannerImageClass = "home-financing-banner-image--desktop";

        if (deviceType === "phone") {
          bannerImage = mobileImage;
          bannerImageClass = "home-financing-banner-image--mobile";
        } else if (deviceType === "tablet") {
          bannerImage = tabletImage;
          bannerImageClass = "home-financing-banner-image--tablet";
        }

        return {
          hasBannerImages: hasBannerImages,
          bannerImage: bannerImage,
          bannerAltText: bannerAltText,
          bannerImageClass: bannerImageClass,
        };
      };
    }

    SDBFinancingView.prototype = Object.create(SCView.prototype);
    SDBFinancingView.prototype.constructor = SDBFinancingView;

    return SDBFinancingView;
  });
